// Tier-aware error message rendered when /agent/copilot returns 429
// rate_limited. Reads kind + user tier and dispatches to the right copy
// + CTA per spec §8.2.
type Kind =
  | "tier_required"
  | "messages_exhausted"
  | "burst_exceeded"
  | "cost_safety_cap"
  | "service_unavailable";

interface Props {
  kind: Kind | (string & {});
  tier: "free" | "pro" | "analyst" | undefined;
}

export function QuotaExceededMessage({ kind, tier }: Props) {
  if (kind === "tier_required") {
    return (
      <div className="rounded-md border border-border bg-card p-4 text-sm">
        <p className="mb-3">
          Copilot is a paid feature. Start your 14-day free trial to unlock it.
        </p>
        <a
          href="https://tapelens.com/pricing"
          className="inline-block rounded-md bg-primary px-3 py-1.5 text-sm font-medium text-primary-foreground hover:opacity-90"
        >
          Start free trial
        </a>
      </div>
    );
  }
  if (kind === "messages_exhausted" && tier === "pro") {
    return (
      <div className="rounded-md border border-border bg-card p-4 text-sm">
        <p className="mb-3">
          You've used all 20 of today's queries. Upgrade to Analyst for 200/day,
          or come back at midnight UTC.
        </p>
        <a
          href="/account/billing"
          className="inline-block rounded-md bg-primary px-3 py-1.5 text-sm font-medium text-primary-foreground hover:opacity-90"
        >
          Upgrade
        </a>
      </div>
    );
  }
  if (kind === "messages_exhausted" && tier === "analyst") {
    return (
      <div className="rounded-md border border-border bg-card p-4 text-sm">
        <p>You've used all 200 of today's queries. Resets at midnight UTC.</p>
      </div>
    );
  }
  if (kind === "burst_exceeded") {
    return (
      <div className="rounded-md border border-border bg-card p-4 text-sm">
        <p>Slow down — please wait a moment before your next query.</p>
      </div>
    );
  }
  if (kind === "cost_safety_cap") {
    return (
      <div className="rounded-md border border-border bg-card p-4 text-sm">
        <p className="mb-3">
          Daily safety cap reached. Please contact support@tapelens.com if you
          need this raised.
        </p>
        <a
          href="mailto:support@tapelens.com"
          className="inline-block rounded-md border border-border px-3 py-1.5 text-sm font-medium text-foreground hover:bg-accent"
        >
          Email support
        </a>
      </div>
    );
  }
  // Unknown kind / service_unavailable → generic fallback
  return (
    <div className="rounded-md border border-border bg-card p-4 text-sm">
      <p>Copilot is temporarily unavailable. Please try again in a moment.</p>
    </div>
  );
}
